import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtBytes, slDateTime } from "@/lib/api";
import { inputCls } from "@/pages/Login";

export function StatsGrid() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-[#6C6560]">Nalaganje …</p>;
  const cards = [["Vse poroke", s.total_weddings, "total"], ["Aktivne", s.active, "active"], ["Prihajajoče", s.upcoming, "upcoming"], ["Potekle", s.expired, "expired"], ["Čakajo na plačilo", s.awaiting_payment, "awaiting"], ["Fotografije", s.photos, "photos"], ["Videi", s.videos, "videos"], ["Skupna shramba", fmtBytes(s.storage_used), "storage"], ["Sodelujoči gostje", s.guests, "guests"], ["Stranke", s.customers, "customers"], ["Skupni prihodki", `${s.revenue} €`, "revenue"], ["Prihodki ta mesec", `${s.monthly_revenue} €`, "monthly"], ["Naročila fizičnih izdelkov", s.physical_orders, "physical"], ["Odprte zahteve", s.open_requests, "requests"], ["Neprebrana sporočila", s.unread_messages, "messages"], ["Prihodki od najema", `${s.rental_revenue} €`, "rental-revenue"], ["Aktivni najemi", s.rentals_active, "rentals"], ["Glasovna sporočila", s.voice_messages, "voice"], ["Vklopljeni Live Wall", s.live_walls, "livewalls"]];
  return (
    <div className="space-y-6" data-testid="admin-stats">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {cards.map(([l, v, k]) => <div key={k} className="card-lux p-5" data-testid={`admin-stat-${k}`}><p className="text-xs text-[#6C6560]">{l}</p><p className="font-display text-3xl mt-2">{v}</p></div>)}
      </div>
      <div className="card-lux p-6">
        <p className="font-display text-2xl mb-4">Prodaja paketov</p>
        {Object.keys(s.package_sales).length === 0 ? <p className="text-sm text-[#6C6560]">Še ni plačanih paketov.</p> : (
          <div className="flex flex-wrap gap-6">{Object.entries(s.package_sales).map(([k, v]) => <div key={k}><p className="text-xs text-[#6C6560]">{k}</p><p className="font-display text-3xl">{v}</p></div>)}</div>
        )}
        <p className="text-xs text-[#968E87] mt-4">Demo poroka ni vključena v statistiko.</p>
      </div>
    </div>
  );
}

export function PackagesEditor() {
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => { api.get("/admin/packages").then((r) => setPkgs(r.data)); }, []);
  const upd = (i, k, v) => setPkgs(pkgs.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  const save = async () => {
    try { const r = await api.put("/admin/packages", pkgs.map((p) => ({ ...p, price: Number(p.price), per_table_price: Number(p.per_table_price || 0), storage_gb: Number(p.storage_gb) }))); setPkgs(r.data); toast.success("Paketi so shranjeni."); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4" data-testid="admin-packages">
      <div className="grid md:grid-cols-2 gap-4">
        {pkgs.map((p, i) => (
          <div key={p.id} className={`card-lux p-5 space-y-3 ${p.active === false ? "opacity-60" : ""}`} data-testid={`admin-package-${p.id}`}>
            <div className="flex gap-2 items-center"><input className={inputCls} value={p.name} onChange={(e) => upd(i, "name", e.target.value)} />
              <label className="text-xs flex items-center gap-1 whitespace-nowrap"><input type="checkbox" checked={p.active !== false} onChange={(e) => upd(i, "active", e.target.checked)} data-testid={`admin-package-active-${p.id}`} /> V ponudbi</label>
              <label className="text-xs flex items-center gap-1 whitespace-nowrap"><input type="checkbox" checked={!!p.includes_qr_designs} onChange={(e) => upd(i, "includes_qr_designs", e.target.checked)} data-testid={`admin-package-qr-${p.id}`} /> QR dizajni vključeni</label></div>
            <div className="grid grid-cols-3 gap-2">
              <label className="text-xs text-[#6C6560]">Na mizo (€)<input type="number" className={`${inputCls} mt-1`} value={p.per_table_price || 0} onChange={(e) => upd(i, "per_table_price", e.target.value)} data-testid={`admin-package-pertable-${p.id}`} /></label>
              <label className="text-xs text-[#6C6560]">Cena (€)<input type="number" className={`${inputCls} mt-1`} value={p.price} onChange={(e) => upd(i, "price", e.target.value)} data-testid={`admin-package-price-${p.id}`} /></label>
              <label className="text-xs text-[#6C6560]">Prostor (GB)<input type="number" className={`${inputCls} mt-1`} value={p.storage_gb} onChange={(e) => upd(i, "storage_gb", e.target.value)} data-testid={`admin-package-storage-${p.id}`} /></label>
            </div>
            <textarea rows={2} className={`${inputCls} h-auto py-2`} value={p.description} onChange={(e) => upd(i, "description", e.target.value)} />
          </div>
        ))}
      </div>
      <button onClick={save} className="btn-dark px-6 h-11" data-testid="admin-packages-save">Shrani pakete</button>
      <p className="text-xs text-[#968E87]">Sprememba prostora velja za nove poroke. Obstoječim porokam prostor povečate v mapi poroke.</p>
    </div>
  );
}

export function RequestsPanel() {
  const [reqs, setReqs] = useState([]);
  const [msgs, setMsgs] = useState([]);
  const load = () => { api.get("/admin/requests").then((r) => setReqs(r.data)); api.get("/admin/messages").then((r) => setMsgs(r.data)); };
  useEffect(load, []);
  const close = async (r) => { await api.patch(`/admin/requests/${r.id}`, { status: r.status === "odprto" ? "zakljuceno" : "odprto" }); load(); };
  const read = async (m) => { await api.patch(`/admin/messages/${m.id}`); load(); };
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="admin-requests">
      <div className="card-lux p-6 space-y-3">
        <p className="font-display text-2xl">Zahteve strank</p>
        {reqs.length === 0 && <p className="text-sm text-[#6C6560]">Ni zahtev.</p>}
        {reqs.map((r) => (
          <div key={r.id} className="border-b border-[#EADBCE]/60 pb-3 text-sm" data-testid="admin-request-row">
            <div className="flex justify-between gap-3"><b>{r.label}</b><button onClick={() => close(r)} className={`text-xs px-3 py-1 rounded-full ${r.status === "odprto" ? "bg-[#FBEBDD]" : "bg-[#E7EFE1]"}`} data-testid="admin-request-toggle">{r.status === "odprto" ? "Odprto" : "Zaključeno"}</button></div>
            <p className="text-[#6C6560]">{r.wedding_title} · {r.requested_by} · {slDateTime(r.created_at)}</p>
            {r.note && <p className="mt-1">{r.note}</p>}
          </div>
        ))}
      </div>
      <div className="card-lux p-6 space-y-3">
        <p className="font-display text-2xl">Sporočila s kontaktnega obrazca</p>
        {msgs.length === 0 && <p className="text-sm text-[#6C6560]">Ni sporočil.</p>}
        {msgs.map((m) => (
          <div key={m.id} className={`border-b border-[#EADBCE]/60 pb-3 text-sm ${m.read ? "opacity-60" : ""}`} data-testid="admin-message-row">
            <div className="flex justify-between gap-3"><b>{m.name}</b>{!m.read && <button onClick={() => read(m)} className="text-xs underline" data-testid="admin-message-read">Označi kot prebrano</button>}</div>
            <a href={`mailto:${m.email}`} className="text-[#B39264]">{m.email}</a> · <span className="text-[#6C6560]">{slDateTime(m.created_at)}</span>
            <p className="mt-1 whitespace-pre-wrap">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AuditPanel() {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setLog(r.data)); }, []);
  return (
    <div className="card-lux overflow-x-auto" data-testid="admin-audit">
      <table className="w-full text-sm">
        <thead className="text-left text-[#6C6560] border-b border-[#EADBCE]"><tr><th className="p-3 font-medium">Čas</th><th className="p-3 font-medium">Uporabnik</th><th className="p-3 font-medium">Dejanje</th><th className="p-3 font-medium">Podrobnosti</th></tr></thead>
        <tbody>{log.map((l) => <tr key={l.id} className="border-b border-[#EADBCE]/40"><td className="p-3 whitespace-nowrap">{slDateTime(l.created_at)}</td><td className="p-3">{l.actor}</td><td className="p-3">{l.action}</td><td className="p-3 text-xs text-[#6C6560] max-w-md truncate">{JSON.stringify(l.details)}</td></tr>)}</tbody>
      </table>
    </div>
  );
}
